import { OwnerIdeasPostRequest } from '@/dtos/ideas/owner-idea/post'

export class OwnerIdeasDraftPostRequest extends OwnerIdeasPostRequest {}
